import { render, staticRenderFns } from "./McnAccountMedia.vue?vue&type=template&id=5fa643b0&scoped=true&"
import script from "./McnAccountMedia.vue?vue&type=script&lang=js&"
export * from "./McnAccountMedia.vue?vue&type=script&lang=js&"
import style0 from "./McnAccountMedia.vue?vue&type=style&index=0&id=5fa643b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa643b0",
  null
  
)

export default component.exports